import { defaultTheme, getThemeOption, isSupportedTheme, themeOptions } from '../data/themeOptions'

const storageKey = 'guildguardian-theme'

export function normalizeTheme(theme) {
  return isSupportedTheme(theme) ? theme : defaultTheme
}

export function getSavedTheme() {
  return normalizeTheme(window.localStorage.getItem(storageKey))
}

export function getThemeState(theme = defaultTheme) {
  return {
    currentTheme: getThemeOption(theme),
    themes: themeOptions
  }
}

export function getNextTheme(theme = defaultTheme) {
  const currentTheme = normalizeTheme(theme)
  const currentIndex = themeOptions.findIndex((option) => option.code === currentTheme)
  const nextIndex = (currentIndex + 1) % themeOptions.length

  return themeOptions[nextIndex].code
}

export function saveTheme(theme) {
  const nextTheme = normalizeTheme(theme)

  window.localStorage.setItem(storageKey, nextTheme)

  return nextTheme
}

export function applyTheme(theme) {
  const nextTheme = normalizeTheme(theme)

  document.documentElement.dataset.theme = nextTheme

  return nextTheme
}
